// Packages
import PropTypes from 'prop-types'

// Components
import ProcedureForm from 'modules/Procedures/components/Form';

// Other
import useApi from 'hooks/useApi';

const ProcedureEditScreen = ({  itemId, onClose, onSubmit }) => {

    const { data: item, put: updateItem, errors } = useApi('/procedures/' + itemId);

	const submit = async (values) => {

        if( await updateItem(values, 'Procedure updated!')) {

            onSubmit();
        }
    }

    return(
        <ProcedureForm 
            errors={errors} 
            procedure={item} 
            onClose={onClose} 
            onSubmit={submit} 
            type='edit' 
        />
    )
}

ProcedureEditScreen.propTypes = {
    itemId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	onClose: PropTypes.func,
    onSubmit: PropTypes.func,
}

ProcedureEditScreen.defaultProps = {
    itemId: null,
	onClose: () => {alert('onClose is not set!')},
    onSubmit: () => {alert('onSubmit is not set!')}
}

export default ProcedureEditScreen;